var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Transition',{attrs:{"name":"message"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_setup.isShow),expression:"isShow"}],ref:"messageRef",class:['t-message', `t-message-${_setup.props.type}`],style:({
      top: _setup.props.top,
      zIndex: _setup.props.zIndex
    })},[_c(_setup.SvgIcon,{staticClass:"t-message-icon",attrs:{"icon":_setup.svgName}}),_c('span',{staticClass:"t-message-text"},[_vm._v(_vm._s(_setup.props.message))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }